import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getSquads } from "../api";

export const fetchSquads = createAsyncThunk(
  "squads/fetchSquads",

  async (searchWord, { dispatch, getState }) => {
    const { token, navCommunity } = getState().auth;

    let organizationId = navCommunity.id;
    const response = await getSquads({
      token,
      organizationId,
      searchWord,
    });
    return response;
  }
);

const initialState = {
  fetching: false,
  fetched: false,
  data: [],
  error: null,
};

export const squadsSlice = createSlice({
  name: "squads",
  initialState,
  extraReducers: {
    [fetchSquads.pending]: (state, action) => {
      state.fetching = true;
    },
    [fetchSquads.fulfilled]: (state, { payload }) => {
      state.fetching = false;
      state.data = payload.data.data;
    },
    [fetchSquads.rejected]: (state, { payload }) => {
      state.error = payload;
      state.fetching = false;
      state.data = [];
    },
  },
});

export default squadsSlice.reducer;
